import Swiper, { Navigation, Autoplay } from 'swiper';
import Globals from './globals';

document.addEventListener('DOMContentLoaded', () => {
  var parseBool = (val) => val == 'true';

  document.querySelectorAll('.swiper').forEach((carousel) => {
    // let slides = parseInt(carousel.getAttribute('data-carousel-slidesperview'));
    let config = {
      modules: [],
      spaceBetween: carousel.getAttribute('data-carousel-spacebetween') ?? 40,
      loop: parseBool(carousel.getAttribute('data-carousel-loop')) ?? true,
      effect: carousel.getAttribute('data-carousel-effect') ?? 'slide',
      autoHeight: parseBool(carousel.getAttribute('data-carousel-autoheight')) ?? true,
      slidesPerView: 1,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      watchOverflow: true,
      keyboard: true,
      a11y: {
        notificationClass: 'swiper-notification visually-hidden',
      },
      on: {
        init: () => {
          carousel.querySelector('.carousel-play')?.classList.add('d-none');
          carousel.querySelector('.carousel-pause')?.addEventListener('click', () => {
            swiper.autoplay.stop();
          })
          carousel.querySelector('.carousel-play')?.addEventListener('click', () => {
            swiper.autoplay.start();
          })
        },
        slidePrevTransitionStart: function() {
          var mindex = null;
          for (var key in this.slides) {
            var slide = this.slides[key];
            if (slide instanceof Element && slide.classList.contains('swiper-slide-visible')) {
              mindex = Math.max(mindex === null ? parseInt(key) : mindex, parseInt(key))
              slide.classList.add('swiper-slide-transitioning')
            }
          }
          if (mindex) {
            var leaving = this.slides[mindex + 1]
            if (leaving) {
              leaving.classList.add('swiper-slide-transitioning')
            }
          }
        },
        slideNextTransitionStart: function() {
          var mindex = null;
          for (var key in this.slides) {
            var slide = this.slides[key];
            if (slide instanceof Element && slide.classList.contains('swiper-slide-visible')) {
              mindex = Math.min(mindex === null ? parseInt(key) : mindex, parseInt(key));
              slide.classList.add('swiper-slide-transitioning')
            }
          }
          if (mindex) {
            var leaving = this.slides[mindex - 1]
            if (leaving) {
              leaving.classList.add('swiper-slide-transitioning')
            }
          }
        },
        slideChangeTransitionEnd: function() {
          for (var key in this.slides) {
            var slide = this.slides[key];
            if (slide instanceof Element && slide.classList.contains('swiper-slide-transitioning')) {
              slide.classList.remove('swiper-slide-transitioning')
            }
          }
        }
      }
    };

    var spv = parseInt(carousel.getAttribute('data-carousel-slidesperview'));
    var breakpoints = {};
    switch (spv) {
      case 6:
        breakpoints[Globals.breakpoints.xl] = {
          slidesPerView: 6
        }
        breakpoints[Globals.breakpoints.lg] = {
          slidesPerView: 4
        }
        breakpoints[Globals.breakpoints.md] = {
          slidesPerView: 3
        }
        // always show at least two slides
        config.slidesPerView = 2;
        break;
      case 4:
        breakpoints[Globals.breakpoints.lg] = {
          slidesPerView: 4
        }
        breakpoints[Globals.breakpoints.md] = {
          slidesPerView: 3
        }
        breakpoints[Globals.breakpoints.xs] = {
          slidesPerView: 2
        }
        break;
      case 3:
        breakpoints[Globals.breakpoints.lg] = {
          slidesPerView: 3
        }
        breakpoints[Globals.breakpoints.sm] = {
          slidesPerView: 2
        }
        break;
      case 2:
        breakpoints[Globals.breakpoints.md] = {
          slidesPerView: 2
        };
        break;
      default:
        // do nothing
      break;
    }
    if (breakpoints) {
      config.breakpoints = breakpoints;
    }
    if (parseBool(carousel.getAttribute('data-carousel-navigation'))) {
      config.navigation = {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
      config.modules.push(Navigation);
    }
    var interval = parseInt(carousel.getAttribute('data-carousel-interval'));
    if (interval > 0) {
      config.autoplay = {
        delay: interval
      }
      config.modules.push(Autoplay);
    }
    console.log(config);
    const swiper = new Swiper(carousel, config);

  })
})